// 📁 src/components/tenant/CustomerSignupPortal.jsx

import React, { useState, useEffect } from 'react';
import { FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

// 🌍 Full ISO country list for dropdown
const allCountries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North Korea',
  'North Macedonia',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Panama',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Lucia',
  'Samoa',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Somalia',
  'South Africa',
  'South Korea',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe'
];

// 🏭 Industry options
const industryOptions = [
  'Agro based Industry',
  'Archi./Engg./Construction',
  'Automation/Industrial Machine',
  'Bank/Non-Bank Fin. Institution',
  'Education',
  'Electronics/Consumer Durables',
  'Energy/Power/Fuel',
  'Garments/Textile',
  'Govt./Semi-Govt./Autonomous',
  'Others',
  'Pharmaceuticals',
  'Hospital/Diagnostic Center',
  'Travel/Airline/Tourism',
  'Manufacturing (Light Industry)',
  'Manufacturing (Heavy Industry)',
  'Hotel/Restaurant',
  'Information Technology (IT)',
  'Logistics/Transportation',
  'Entertainment/Recreation',
  'Media/Advertising/Event Mgt.',
  'NGO/Development',
  'Real Estate/Development',
  'Wholesale/Retail/Export-Import',
  'Telecommunication',
  'Food & Beverage Industry',
  'Security Service',
  'Fire, Safety & Protection',
  'E-Commerce/F-Commerce'
];

export default function CustomerSignupPortal({ mode = 'public' }) {
  const [formData, setFormData] = useState({
    personName: '',
    companyName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    country: '',
    industry: '',
    employeeSize: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [confirmation, setConfirmation] = useState('');
  const [showWarning, setShowWarning] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const registrationMode = localStorage.getItem('registrationMode') || 'public';
    if (registrationMode === 'private' && mode === 'public') {
      setShowWarning(true);
    }
  }, [mode]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setConfirmation('❌ Passwords do not match');
      return;
    }

    const otp = Math.floor(10000 + Math.random() * 90000).toString();
    sessionStorage.setItem('otp', otp);
    localStorage.setItem('email', formData.email);
    localStorage.setItem('password', formData.password);

    // ✅ Generate tenantId and sync accountRegistry
    const tenantId = `TXN-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    const registry = JSON.parse(localStorage.getItem('accountRegistry') || '{}');
    registry[formData.email] = {
      tenantId,
      password: formData.password,
      companyName: formData.companyName,
      country: formData.country,
      industry: formData.industry,
      employeeSize: formData.employeeSize,
      registrationType: mode // 🔹 Tag public vs private
    };
    localStorage.setItem('accountRegistry', JSON.stringify(registry));

    console.log(`📨 Dispatching OTP to ${formData.email} with OTP ${otp}`);

    try {
      const response = await fetch('http://localhost:3001/api/email/send-otp-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: formData.email, otp })
      });

      const result = await response.json();
      if (result.success) {
        console.log(`✅ OTP email sent to ${formData.email}`);
        setConfirmation(`OTP has been sent to ${formData.email}`);
        setTimeout(() => navigate('/otp'), 1000);
      } else {
        console.error('❌ Error sending OTP email:', result.error);
        setConfirmation('Failed to send OTP. Please try again.');
      }
    } catch (error) {
      console.error('❌ Network error:', error);
      setConfirmation('Failed to send OTP. Please try again.');
    }
  };

  // 🔒 Show construction mode warning if site is private but user accessed public route
  if (showWarning) {
    return (
      <div className="p-8 bg-yellow-50 rounded shadow w-full max-w-xl mx-auto text-center">
        <h2 className="text-xl font-bold text-yellow-800 mb-2">🚧 Construction Mode</h2>
        <p className="text-gray-700">
          The site is currently in construction mode and not opened yet for public access. Please
          contact our team for internal registration or customized onboarding.
        </p>
      </div>
    );
  }

  return (
    <div className="p-8 bg-white rounded shadow w-full max-w-xl mx-auto">
      <h2 className="text-3xl font-bold text-center mb-2">Create a Talentraxion Account</h2>
      <p className="text-sm text-gray-600 text-center mb-6">All Fields are required to fill up</p>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="personName"
          placeholder="Person Name"
          value={formData.personName}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded text-gray-500"
        />
        <input
          type="text"
          name="companyName"
          placeholder="Company Name"
          value={formData.companyName}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded text-gray-500"
        />
        <input
          type="email"
          name="email"
          placeholder="Admin Email"
          value={formData.email}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded text-gray-500"
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded text-gray-500"
        />

        {/* 🌍 Country Dropdown */}
        <select
          name="country"
          value={formData.country}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded text-gray-500"
        >
          <option value="">Select Country</option>
          {allCountries.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>

        {/* 🏭 Industry Dropdown */}
        <select
          name="industry"
          value={formData.industry}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded text-gray-500"
        >
          <option value="">Select Industry</option>
          {industryOptions.map((i) => (
            <option key={i} value={i}>
              {i}
            </option>
          ))}
        </select>

        {/* 👥 Employee Size Dropdown */}
        <select
          name="employeeSize"
          value={formData.employeeSize}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded text-gray-500"
        >
          <option value="">Select Employee Size</option>
          <option value="10-100">10–100</option>
          <option value="100-500">100–500</option>
          <option value="1000+">1000+</option>
        </select>

        <div className="relative">
          <FaLock className="absolute left-3 top-3 text-gray-400" />
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
            className="w-full pl-10 pr-10 p-3 border rounded text-gray-500"
          />
          <span
            className="absolute right-3 top-3 text-gray-500 cursor-pointer"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <div className="relative">
          <FaLock className="absolute left-3 top-3 text-gray-400" />
          <input
            type={showPassword ? 'text' : 'password'}
            name="confirmPassword"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            className="w-full pl-10 pr-10 p-3 border rounded text-gray-500"
          />
          <span
            className="absolute right-3 top-3 text-gray-500 cursor-pointer"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <p className="text-xs text-gray-600 text-center">
          By continuing, you agree to our <span className="underline">Terms</span> and{' '}
          <span className="underline">Privacy Policy</span>.
        </p>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-3 rounded hover:bg-blue-700"
        >
          Register
        </button>
        {confirmation && <p className="text-sm text-center mt-2 text-green-700">{confirmation}</p>}
        <p className="text-sm text-center mt-2">
          Already have an account?{' '}
          <span className="text-blue-600 underline cursor-pointer">Sign in</span>
        </p>
      </form>
    </div>
  );
}
